import {
  collection,
  onSnapshot,
  orderBy,
  query,
  type DocumentData,
  type Unsubscribe,
} from 'firebase/firestore';
import { useEffect, useState } from 'react';
import type { RouteReportSnapshot } from '@citizen-walk/shared-types';
import { db } from '../../lib/firebase';

export interface RouteReportSnapshotWithId extends RouteReportSnapshot {
  id: string;
}

export type RouteReportSnapshotsState =
  | { status: 'loading'; reports: RouteReportSnapshotWithId[]; error: null }
  | { status: 'ready'; reports: RouteReportSnapshotWithId[]; error: null }
  | { status: 'error'; reports: RouteReportSnapshotWithId[]; error: Error };

function mapSnapshotDoc(snap: { id: string; data: () => DocumentData }): RouteReportSnapshotWithId {
  return { ...(snap.data() as Omit<RouteReportSnapshot, 'id'>), id: snap.id };
}

/** 保存済み路線調査スナップショットを作成日時降順で購読する (`useAreaReportSnapshots` と同じパターン)。 */
export function useRouteReportSnapshots(districtId: string | null): RouteReportSnapshotsState {
  const [state, setState] = useState<RouteReportSnapshotsState>({
    status: 'loading',
    reports: [],
    error: null,
  });
  useEffect(() => {
    if (!districtId) return;
    const q = query(
      collection(db, 'districts', districtId, 'routeReports'),
      orderBy('createdAt', 'desc'),
    );
    const unsub: Unsubscribe = onSnapshot(
      q,
      (snap) => setState({ status: 'ready', reports: snap.docs.map(mapSnapshotDoc), error: null }),
      (error) => setState({ status: 'error', reports: [], error }),
    );
    return () => unsub();
  }, [districtId]);
  return state;
}
